"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountType = exports.ProductType = exports.OptionType = void 0;
var OptionType;
(function (OptionType) {
    OptionType["drop_down"] = "drop_down";
    OptionType["color"] = "color";
})(OptionType = exports.OptionType || (exports.OptionType = {}));
var ProductType;
(function (ProductType) {
    ProductType["physical"] = "physical";
    ProductType["digital"] = "digital";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var DiscountType;
(function (DiscountType) {
    DiscountType["undefined"] = "UNDEFINED";
    DiscountType["none"] = "NONE";
    DiscountType["amount"] = "AMOUNT";
    DiscountType["percent"] = "PERCENT";
})(DiscountType = exports.DiscountType || (exports.DiscountType = {}));
//# sourceMappingURL=product.dto.js.map